import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const httpLink = new HttpLink({
  uri: 'https://graphql-tufwksmdha-uc.a.run.app/graphql', // Replace with your function URL
  //uri: 'http://127.0.0.1:5001/edupractice-db513/us-central1/graphql', // Replace with your function URL
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

export default client;
